import api from '@/shared/api/api-client';
import { toLinkedInUrlBody } from '@/shared/linkedin/linkedin-url';

import type { AdminDraft } from '../../_shared/domain/administrator-draft.model';
import type { AddAdministratorGateway } from './add-administrator.gateway';

/**
 * Real implementation over the shared api client. The single place that knows
 * the invitation-send endpoint and the draft → snake_case body mapping (kept
 * 1:1 with the original `AddAdmin` page's inline `api.post`).
 */
export const httpAddAdministratorGateway: AddAdministratorGateway = {
  sendInvitation: async (draft: AdminDraft) => {
    await api.post('/invitations/send', {
      first_name: draft.firstName.trim(),
      last_name: draft.lastName.trim(),
      email: draft.email.trim().toLowerCase(),
      role: draft.role,
      // Normalised, `null` when empty; as Add user sends it (#617).
      linkedin_url: toLinkedInUrlBody(draft.linkedinUrl),
    });
  },
};
